import React, { useState } from 'react';
import { Modal, Button, message, Tooltip } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { LicenseDetailContainer } from '../../containers';

import styles from './LicenseDetail.module.scss';

const LicenseDetailModal = props => {
  const [visible, setVisible] = useState(false);
  const { id, status, notifyInfo } = props;

  const showModal = () => setVisible(true);
  const handleCancel = () => setVisible(false);

  const handleIdCopy = () => {
    message.success('ID copied');
  };

  const title = (
    <div>
      <div className="inline-block">
        License Detail &nbsp;
        <CopyToClipboard text={id} onCopy={handleIdCopy}>
          <span className={styles.clickable}>{`(#${id})`}</span>
        </CopyToClipboard>
      </div>
      <div className="inline-block little-margin-left">
        - &nbsp;
        {status.toLowerCase() === 'approved' ? (
          <>
            <span className={'text-capitalize ' + styles.licenseApproved}>{status}</span> by{' '}
            {props.creator}
          </>
        ) : status.toLowerCase() === 'rejected' ? (
          <span className={'text-capitalize ' + styles.licenseRejected}>{status}</span>
        ) : (
          <span className={'text-capitalize ' + styles.licensePending}>{status}</span>
        )}
      </div>
    </div>
  );

  return (
    <div>
      <Tooltip title="License request details">
        <Button className={styles.actionButton} type="primary" onClick={showModal}>
          Detail
        </Button>
      </Tooltip>

      <Modal
        title={title}
        width={880}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        <LicenseDetailContainer {...props} closeModal={handleCancel} notifyInfo={notifyInfo} />
      </Modal>
    </div>
  );
};

export default LicenseDetailModal;
